export const chorePageTranslateEn = {
    LIST_CHORES:{
        ADD_NEW_CHORE_BUTTON: "Add new chore",
        NOT_CHORES_TEXT: "No chores here yet. Get started by adding a new one!",
        BACK_BUTTON:"’s Chores"
    },
}